import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import $ from 'jquery';

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Followup = ({ show, onClose, selectedId, data, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    // page table data fetch
    const fetchData = () => {
        axios.get(`${baseURL}/subscriberfollowup/all/${selectedId}`)
            .then(response => {
                setData(response.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };
    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, []);

    const lowBalanceProducts = data?.products?.filter(product => product.balance <= 3 && (product.status == 3 || product.status == 5)) || [];

    // Optionally make names unique
    const productNames = [...new Set(lowBalanceProducts.map(p => p.product_name + ' ( ' + p.duration_name + ' )'))];

    const productids = [...new Set(lowBalanceProducts.map(p => p.product_id))];

    
    const [isDisVisible, setIsDisVisible] = useState({
        completed: true,
        cancelled: false
    });

    const DistoggleDiv = (section) => {
        setIsDisVisible((prev) => ({
            completed: section === 'completed',
            cancelled: section === 'cancelled',
        }));
    };

    const tableRef = useRef(null);
    useEffect(() => {
        if(hasFetched){
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "230px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":

                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // capsfirst
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    }

    const [followup_date, setFollowup_date] = useState(null);
    const [followup_time, setFollowup_time] = useState(null);

    const [progress, setProgress] = useState(0);
    const [score, setScore] = useState(0);
    const [conversation, setConversation] = useState('');
    const [reason, setReason] = useState('');
    const [re_appointment_date, setReDate] = useState('');
    const [re_appointment_time, setReTime] = useState('');

    const handleDateChange = (dateValue) => {
        if (dateValue) {
            const formattedDate = dateValue.format('YYYY-MM-DD');
            setFollowup_date(formattedDate);
        } else {
            setFollowup_date('');
        }
    };

    const handleTimeChange = (timeValue) => {
        if (timeValue) {
            const formattedTime = timeValue.format('H:mm');
            setFollowup_time(formattedTime);
        } else {
            setFollowup_time('');
        }
    };

    const handleReDateChange = (dateValue) => {
        if (dateValue) {
            const formattedDate = dateValue.format('YYYY-MM-DD');
            setReDate(formattedDate);
        } else {
            setReDate('');
        }
    };

    const handleReTimeChange = (timeValue) => {
        if (timeValue) {
            const formattedTime = timeValue.format('H:mm');
            setReTime(formattedTime);
        } else {
            setReTime('');
        }
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!followup_date) {
            newErrors.date = "This Field is Required.";
        }
        
        if (!followup_time) {
            newErrors.time = "This Field is Required.";
        }
        
        
        // Check if the "conversation" textarea is filled
        if (isDisVisible.completed && !conversation.trim()) {
            newErrors.conversation = "This Field is Required.";
        }
        
        // Check if the "reason" textarea is filled when "Cancelled" is selected
        if (isDisVisible.cancelled && !reason.trim()) {
            newErrors.reason = "This Field is Required.";
        }
        
        return newErrors;
    };

    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    
    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        let clr = null;
        let bord = null;
        if (score === 0) {
            clr = '#ADD8E6';
            bord = '#7BAED9';
        } else if (score === 1) {
            clr = '#e7ffcb';
            bord = '#78b636';
        } else if (score === -1) {
            clr = '#FFB3B3';
            bord = '#D95B5B';
        } else if (score === '') {
            clr = '';
            bord = '';
        }

        const productsnoList = productids.map(item => item).join(',');
        const postData = { 
            subscriber: selectedId,
            appointment_date: followup_date,
            appointment_time: followup_time,
            score: score,
            progress: progress,
            conversation: conversation,
            reason: reason,
            re_appointment_date: re_appointment_date,
            re_appointment_time: re_appointment_time,
            followup_score_bg: clr,
            followup_score_border: bord,
            created_by: user_id,
            product_ids: productsnoList,
        };
        axios.post(`${baseURL}/subscriberfollowup`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Follow Up Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Follow up Updation Failed");
            });
    };


    return (

        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Renewal Followup</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_mobile}</label>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Subscription Details</label>
                            <div className='d-inline'>
                                {productNames.length > 0 ? (
                                    productNames.map((name, index) => (
                                        <span key={index} className='text-black fs-6 font-w500'>
                                            {name}
                                            {index < productNames.length - 1 && <span>  ,  </span>}
                                        </span>
                                    ))
                                ) : (
                                    <span className='text-muted fs-6 font-w400'>No expiring subscriptions</span>
                                )}
                                {/* <span className='text-black fs-6 font-w500'>Breakbox Mini ( Weekly )</span>
                                <span className='text-black fs-6 font-w500'>  ,  </span>
                                <span className='text-black fs-6 font-w500'>Lunchbox Mini ( Weekly )</span>
                                <span className='text-black fs-6 font-w500'>  ,  </span>
                                <span className='text-black fs-6 font-w500'>Dinnerbox Mini ( Weekly )</span> */}
                            </div>
                        </div>
                        <div className="col-lg-6 my-2">
                            <label className="text-black font-w500 fs-7">Appointment Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                <div className='input-group-text bg-transparent border-0 px-0 rounded-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Date'
                                    onChange={handleDateChange}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                            {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                        </div>
                        <div className="col-lg-6 my-2">
                            <label className="text-black font-w500 fs-7">Appointment Time<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                <div className='input-group-text bg-transparent border-0 px-0 rounded-0'>
                                    <i className='fa-solid fa-clock fs-4'></i>
                                </div>
                                <DatePicker placeholder='Select Time'
                                    disableDayPicker
                                    onChange={handleTimeChange}
                                    format="hh : mm A"
                                    showTime={{
                                            format: "hh:mm A", // 12-hour format for display
                                            use12Hours: true, // 12-hour clock
                                        }}
                                    plugins={[
                                        <TimePicker />
                                    ]}
                                />
                            </div>
                            {errors.time && <div className="text-danger fs-8 mt-1">{errors.time}</div>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-6 mb-2">Progress</label>
                            <div className='row mb-3'>
                                <div className='col-lg-6 mb-2'>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input me-1"
                                            type="radio"
                                            name="product_type"
                                            value="option1"
                                            checked={isDisVisible.completed}
                                            onChange={() => {
                                                DistoggleDiv('completed');
                                                setProgress(0);
                                            }}
                                        />
                                        <label className="form-check-label text-black font-w400 fs-7">
                                            Completed
                                        </label>
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input me-1"
                                            type="radio"
                                            name="product_type"
                                            value="option2"
                                            checked={isDisVisible.cancelled}
                                            onChange={() => {
                                                DistoggleDiv('cancelled');
                                                setProgress(1);
                                                setScore('');
                                            }}
                                        />
                                        <label className="form-check-label text-black font-w400 fs-7">
                                            Cancelled
                                        </label>
                                    </div>
                                </div>
                                
                                {isDisVisible.completed && (
                                    <>
                                        <div className='col-lg-6 mb-2'>
                                            <div className='row'>
                                                <div className="col-lg-12 d-flex align-items-center gap-3 mb-2">
                                                    <div className="d-flex">
                                                        <input
                                                            className="form-check-input me-1"
                                                            type="radio"
                                                            name="size_type"
                                                            value="option1"
                                                            onChange={() => {
                                                                setScore(1);
                                                            }}
                                                        />
                                                        <label className="form-check-label fs-6 text-black font-w400">
                                                            <span>Positive</span>
                                                            <span>(+1)</span>
                                                        </label>
                                                    </div>

                                                    <div className="d-flex">
                                                        <input
                                                            className="form-check-input me-1"
                                                            type="radio"
                                                            name="size_type"
                                                            value="option2"
                                                            onChange={() => {
                                                                setScore(-1);
                                                            }}
                                                        />
                                                        <label className="form-check-label fs-6 text-black font-w400">
                                                            <span>Negative</span>
                                                            <span>(-1)</span>
                                                        </label>
                                                    </div>

                                                    <div className="d-flex">
                                                        <input
                                                            className="form-check-input me-1"
                                                            type="radio"
                                                            name="size_type"
                                                            value="option2"
                                                            onChange={() => {
                                                                setScore(0);
                                                            }}
                                                            defaultChecked
                                                        />
                                                        <label className="form-check-label fs-6 text-black font-w400">
                                                            <span>Neutral</span>
                                                            <span>(0)</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <label className="text-black font-w500 fs-7">Conversation<span className="required">*</span></label>
                                            <textarea rows={8} className="form-control" name="comment" placeholder="Conversation"
                                                maxLength={100}
                                                value={conversation} 
                                                onChange={(e) => setConversation(formatName(e.target.value))} 
                                            />
                                            {errors.conversation && <div className="text-danger fs-8 mt-1">{errors.conversation}</div>}
                                        </div>
                                    </>
                                )}

                                <div className='col-lg-12'>
                                    <div className='row'>
                                        {isDisVisible.cancelled && (
                                            <>
                                                <div className="col-lg-12 mt-2 mb-3">
                                                    <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                                    <textarea rows={8} className="form-control" name="comment" placeholder="Reason"
                                                        maxLength={100}
                                                        value={reason} 
                                                        onChange={(e) => setReason(formatName(e.target.value))} 
                                                    />
                                                    {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                                                </div>
                                                <div className="col-lg-6 mb-2">
                                                    <label className="text-black font-w500 fs-7">Re Appointment Date</label>
                                                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                                        <div className='input-group-text bg-transparent border-0 px-0 rounded-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                        <DatePicker placeholder='Select Date'
                                                            onChange={handleReDateChange}
                                                            format="DD-MM-YYYY"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-2">
                                                    <label className="text-black font-w500 fs-7">Re Appointment Time</label>
                                                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                                        <div className='input-group-text bg-transparent border-0 px-0 rounded-0'>
                                                            <i className='fa-solid fa-clock fs-4'></i>
                                                        </div>
                                                        <DatePicker
                                                            disableDayPicker
                                                            onChange={handleReTimeChange}
                                                            placeholder='Select Time'
                                                            format="hh : mm A"
                                                            showTime={{
                                                                format: "hh:mm A", // 12-hour format for display
                                                                use12Hours: true, // 12-hour clock
                                                            }}
                                                            plugins={[
                                                                <TimePicker />
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {datas.length>0 ? (
                            <div className='col-lg-12 mb-2'>
                                <label className="text-black font-w600 fs-5 mb-3">Follow Up History</label>
                                <div className="table-container"  >
                                    <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-80px text-start'>Date / Time</th>
                                                <th className='min-w-80px text-start'>Subscription Details</th>
                                                <th className='min-w-50px text-center'>Score</th>
                                                <th className='min-w-100px'>Conversation</th>
                                                <th className='min-w-80px'>Reschedule</th>
                                                <th className='min-w-100px'>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {datas.map((data, index) => (
                                            <tr>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{formatDate(data.appointment_date)}</label>
                                                    <div className='d-block'>
                                                        <label className='text-dark font-w600 fs-8'>{convert24to12(data.appointment_time)}</label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'> {data.product_details}</span></Tooltip>} >
                                                        <label className='text-black font-w400 fs-7 w-100px text-truncate'>
                                                            {data.product_details}
                                                        </label>
                                                    </OverlayTrigger>
                                                </td>
                                                <td className='text-center'>
                                                    <label className='text-black font-w400 fs-7'>
                                                        <span>{data.score ? data.score : '-'}</span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'> {data.conversation}</span></Tooltip>} >
                                                        <label className='text-black font-w400 fs-7 w-100px text-truncate'>
                                                            {data.conversation}
                                                        </label>
                                                    </OverlayTrigger>
                                                </td>
                                                <td>
                                                    {data.re_appointment_date ? (
                                                        <>
                                                            <label className='text-black font-w400 fs-7'>{formatDate(data.re_appointment_date)}</label>
                                                            <div className='d-block'>
                                                                <label className='text-dark font-w600 fs-8'>{convert24to12(data.re_appointment_time)}</label>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <label className='text-black font-w400 fs-7'>-</label>
                                                    )}
                                                </td>
                                                <td>
                                                    {data.reason ? (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'> {data.reason}</span></Tooltip>} >
                                                            <label className='text-black font-w400 fs-7 w-175px text-truncate'>
                                                                {data.reason}
                                                            </label>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <label className='text-black font-w400 fs-7'>-</label>
                                                    )}
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null}
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit} >Create Followup <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Followup;
